/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { EDITOR_STATE, Editor } from "../../Editor";
import { ErrorFallback } from "./ErrorFallback";
import { useStateWithEvent } from "../hooks";
import { ViewLoading } from "./View/ViewLoading";
import { EditorLogin } from "./EditorLogin";
import { EditorMain } from "./EditorMain";

/**
 * Component props
 */
export interface IEditorEntrypointProps {
	editorInstance: Editor;
}

/**
 *  Editor Entrypoint Component
 *
 * @param props Component props
 */
export const EditorEntrypoint: React.FunctionComponent<IEditorEntrypointProps> = ({ editorInstance }) => {
	const initState = useStateWithEvent(editorInstance.onInitStateChange, () => editorInstance.getInitState());
	console.log('EditorEntrypoint render, initState:', initState);

	if (initState === EDITOR_STATE.INITIALIZING) {
		return (
			<div className="adpt-editor adpt-editor__main adpt-editor__main--initializing">
				<ViewLoading />
			</div>
		);
	} else if (initState === EDITOR_STATE.AWAITING_AUTH) {
		return (
			<EditorLogin editorInstance={editorInstance} />
		);
	} else if (initState === EDITOR_STATE.ERROR) {
		return (
			<div className="adpt-editor adpt-editor__main adpt-editor__main--error">
				<ErrorFallback />
			</div>
		);
	} else if (initState === EDITOR_STATE.READY) {
		return (
			<EditorMain editorInstance={editorInstance} />
		)
	} else if (initState === EDITOR_STATE.INIT_AUTH_FAILED) {
		return (
			<div className="adpt-editor adpt-editor__main adpt-editor__main--error">
				<ErrorFallback
					title="Authentication Failed"
					message="Failed to authenticate with the provided access token."
					canReload={false}
				/>
			</div>
		);
	}
};
